import MobileHero from '../../assets/Mobile Hero.png'

const SUBSCRIBE_URL = "https://test3.ntubedglobal.com/";

export default function MobileBanner() {
    return (
        <div className="block md:hidden relative w-full h-[40em]">
            <img
                src={MobileHero}
                className="w-full h-full object-cover absolute top-0 left-0 z-0 "
                alt="Mobile Hero"

            />

            <div className="relative z-10 flex flex-col justify-between h-full text-white bg-black/50 place-items-center p-6">
                <div className='mt-5'>
                    <h1 className="text-3xl uppercase text-center font-extrabold">
                        Welcome to Pharmtrix
                    </h1>
                    <p className="text-base text-center mt-4">
                        Pharmtrix is a Pharmacy Inventory and Prescription management system that lets you take control of your pharmacy operations. Our solution is scalable and streamlines the functionality of your workflow, improving each segment along the way, including inventory management, inventory replenishment, stock management, sale transactions and more.
                    </p>
                </div>

                <button className=" bg-blue-500 mt-5 rounded-full text-white px-6 py-3 self-center shadow-md transition" onClick={() => { window.open(SUBSCRIBE_URL, '_blank') }}>
                    Subscribe
                </button>
            </div>
        </div>
    )
}
